function isIEDomain (){
	return window.location.hostname.indexOf('.ie')!=-1
}

function isStagingDomain () {
	return (window.location.hostname.indexOf('staging')!=-1 || window.location.hostname.indexOf('stage')!=-1)
}

function isLocalDomain () {
	return (window.location.hostname.indexOf('localhost')!=-1 || window.location.hostname.indexOf('127.0.0.1')!=-1)
}

export { isIEDomain, isStagingDomain, isLocalDomain };
